<script setup lang="ts">
import { RouterLink } from 'vue-router'

// Order follows the prototype. RouterLink marks the current page with aria-current="page".
const items = [
  { name: 'performance', label: 'Performance' },
  { name: 'engines', label: 'Dynamic Engines' },
  { name: 'review', label: 'Review & Approve' },
  { name: 'pause', label: 'Pause' },
  { name: 'price-fetch', label: 'Price Fetch' },
  { name: 'guardrails', label: 'Guardrails' },
  { name: 'audit', label: 'Audit' },
] as const
</script>

<template>
  <nav
    aria-label="Main"
    class="z-[1] w-sidebar shrink-0 bg-surface shadow-sidebar max-[900px]:w-full"
    data-testid="app-sidebar"
  >
    <ul class="flex flex-col gap-2.5 px-5 pt-10 pb-5">
      <li v-for="item in items" :key="item.name">
        <RouterLink
          :to="{ name: item.name }"
          :data-testid="`app-sidebar-nav-link-${item.name}`"
          class="flex h-[46px] items-center rounded-md px-5 text-body-sm font-semibold text-primary hover:bg-canvas aria-[current=page]:bg-primary aria-[current=page]:text-on-bar"
        >
          {{ item.label }}
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>
